var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#447099",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H2V8H12V6H2C1.46973 6.00053 0.961329 6.21141 0.586371 6.58637C0.211413 6.96133 0.000529477 7.46973 0 8V28C0.000529477 28.5303 0.211413 29.0387 0.586371 29.4136C0.961329 29.7886 1.46973 29.9995 2 30H22C22.5303 29.9995 23.0387 29.7886 23.4136 29.4136C23.7886 29.0387 23.9995 28.5303 24 28V18H22V28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H2V8H12V6H2C1.46973 6.00053 0.961329 6.21141 0.586371 6.58637C0.211413 6.96133 0.000529477 7.46973 0 8V28C0.000529477 28.5303 0.211413 29.0387 0.586371 29.4136C0.961329 29.7886 1.46973 29.9995 2 30H22C22.5303 29.9995 23.0387 29.7886 23.4136 29.4136C23.7886 29.0387 23.9995 28.5303 24 28V18H22V28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 5.6V0H21.6V5.6H16V8.4H21.6V14H24.4V8.4H30V5.6H24.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.09227425c8c167ab410b0eba04db7440.svg";
export { ForwardRef as ReactComponent };